module.exports = "https://deal-img.imgix.net/consumer/modern/notification.c3820a1f.png";